<template>
  <!-- Authors Table Card -->
  <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: '20px' }">
    <a-row :gutter="24" type="flex">
      <a-col :span="24" class="mb-24">
        <a-form layout="inline" :form="dataForm" @submit="getDataList" class="ml-20">
          <a-form-item label="会员姓名">
            <a-input v-model="dataForm.customer_name" allowClear placeholder="会员姓名" />
          </a-form-item>
          <a-form-item label="会员权益名称">
            <a-input v-model="dataForm.name" allowClear placeholder="权益名称" />
          </a-form-item>
          <a-form-item label="使用类型">
            <a-select v-model="dataForm.use_type" allowClear style="width: 160px" placeholder="请选择使用类型">
              <a-select-option value="1">未使用</a-select-option>
              <a-select-option value="2">已使用</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="exportHandle">导出</a-button>
          </a-form-item>
          <!-- <a-form-item>
            <a-button type="primary" @click="addOrUpdateHandle()">新增会员级别</a-button>
          </a-form-item> -->
        </a-form>
        <a-table :columns="columns" :data-source="dataList" :pagination="false" rowKey="vip_id"
          :loading="dataListLoading" :scroll="{ x: 1500 }">
          <template slot="use_type" slot-scope="text, row">
            <a-tag :color="text === '1' ? 'red' : 'green'">{{ text === '1' ? '未使用' : '已使用' }}</a-tag>
          </template>
          <template slot="editBtn" slot-scope="text, row">
            <a-button type="link" class="btn-edit"
              @click="addOrUpdateHandle({ customer_id: row.customer_id, info: row })">
              点击核销
            </a-button>
            <a-button type="link" class="btn-edit" @click="deleteHandle(row.id)">
              删除
            </a-button>
          </template>
        </a-table>
      </a-col>
      <!-- / Authors Table Column -->
    </a-row>

    <a-pagination class="mr-20 float-right" show-size-changer :current="page" :total="total"
      :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange" @change="pageCurrentChangeHandle" />
    <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
  </a-card>
  <!-- / Authors Table Card -->
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "@/components/Customer/components/addbenefit.vue";
export default {
  mixins: [viewModule],
  components: {
    addorupdate,
  },
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/admin/customer/benefitpage",
        deleteURL: "/admin/customer/benefitdelete",
        exportURL: "/admin/customer/customerBenefitExport",
      },
      exportFileName: "会员权益信息导出",
      dataForm: {
        customer_name: "",
        name: "",
        use_type: undefined
      },
      columns: [
        {
          title: "会员姓名",
          dataIndex: "customer.customer_name",
          align: 'center',
          width: 200
        },
        {
          title: "会员权益名称",
          dataIndex: "name",
          align: 'center',
          width: 200
        },
        {
          title: "使用状态",
          dataIndex: "use_type",
          scopedSlots: { customRender: "use_type" },
          align: 'center',
          width: 200
        },
        {
          title: "核销时间",
          dataIndex: "use_time",
          align: 'center',
          width: 200
        },
        {
          title: "创建时间",
          dataIndex: "create_time",
          align: 'center',
          width: 200
        },
        {
          title: "",
          scopedSlots: { customRender: "editBtn" },
          width: 200,
          fixed: "right",
        },
      ],
    };
  },
  methods: {},
};
</script>